(() => {
  const PICKER_SELECTOR = '.st-catalog-navigator__picker';

  function closePickers(exceptPicker = null) {
    document.querySelectorAll(`${PICKER_SELECTOR}[open]`).forEach((picker) => {
      if (picker !== exceptPicker) picker.removeAttribute('open');
    });
  }

  function enhancePickers() {
    document.querySelectorAll(PICKER_SELECTOR).forEach((picker) => {
      if (picker.dataset.stPickerReady === 'true') return;
      picker.dataset.stPickerReady = 'true';
      picker.addEventListener('toggle', () => {
        if (picker.open) closePickers(picker);
      });
    });
  }

  document.addEventListener('click', (event) => {
    const clickedPicker = event.target instanceof Element
      ? event.target.closest(PICKER_SELECTOR)
      : null;
    if (!clickedPicker) closePickers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPickers = Array.from(document.querySelectorAll(`${PICKER_SELECTOR}[open]`));
    if (openPickers.length === 0) return;
    const activePicker = openPickers.find((picker) => picker.contains(document.activeElement)) || openPickers.at(-1);
    closePickers();
    activePicker?.querySelector('summary')?.focus();
  });

  function initialize() {
    enhancePickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE))) {
      initialize();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
